import { gql } from "@apollo/client";

export const CREATE_EDUCATION_LEVEL = gql`
  mutation CreateEducationLevel($input: EducationLevelInput) {
    createEducationLevel(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_EDUCATION_LEVEL = gql`
  mutation UpdateEducationLevel($id: ID!, $input: EducationLevelInput) {
    updateEducationLevel(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_EDUCATION_LEVEL = gql`
  mutation DeleteEducationLevel($id: ID!) {
    deleteEducationLevel(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_EDUCATION_LEVEL_BY_MEMBER = gql`
  query GetEducationLevelByMember($memberId: ID!) {
    getEducationLevelByMember(memberId: $memberId) {
      _id
      memberId {
        _id
        profile
        firstNameKh
        lastNameKh
        gender
        phoneNumber
        email
        role
      }
      instituteOrUniversityId {
        _id
        nameKh
        nameEng
      }
      level
      majorsId {
        _id
        majorsNameKh
        majorsNameEng
      }
      startDate
      endDate
    }
  }
`;

export const GET_EDUCATION_LEVEL_PAGINATION = gql`
  query GetEducationLevelPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
    $memberId: String
  ) {
    getEducationLevelPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
      memberId: $memberId
    ) {
      data {
        _id
        memberId {
          _id
          profile
          firstNameKh
          lastNameKh
          gender
          phoneNumber
          email
          role
        }
        instituteOrUniversityId {
          _id
          nameKh
          nameEng
        }
        level
        majorsId {
          _id
          majorsNameKh
          majorsNameEng
        }
        startDate
        endDate
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
